import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useAssignRequestsToUser(userId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (requestIds: number[]) =>
      apiClient.url(`/users/${userId}/requests`).put({ requestIds }).res(),
    onError: () => {
      toast.add({
        description: "Failed to update requests",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: profileKeys.requestsByUserId(userId),
      });
      toast.add({
        description: "Requests updated successfully",
        timeout: 3000,
        type: "success",
      });
    },
  });
}
